<template>
  <v-dialog v-model="open" :max-width="width || '500px'" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :small="small" :rounded="rounded" :outlined="outlined" :text="text"
        :disabled="disabled" :class="actionClass" :color="actionColor">
        {{ actionText }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>

      <v-card-text>
        <div class="mb-4">{{ description }}</div>
        
        <v-alert type="info" outlined dense class="mb-4">
          Para confirmar, digite <strong>{{ expectedText }}</strong> no campo abaixo:
        </v-alert>

        <v-text-field
          v-model="confirmationInput"
          label="Confirmação"
          outlined
          dense
          hide-details
          @keyup.enter="canConfirm && callAction()"
          placeholder="Digite o texto de confirmação aqui"
        ></v-text-field>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="cancel">
          Cancelar
        </v-btn>
        <v-btn :loading="loading" :disabled="!canConfirm" color="primary" text @click="callAction">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ActionConfirmModal',
  props: {
    width: String,
    small: Boolean,
    rounded: Boolean,
    text: Boolean,
    outlined: Boolean,
    disabled: Boolean,
    actionText: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    action: {
      type: Function,
      required: true,
    },
    expectedText: {
      type: String,
      required: true,
    },
    actionColor: {
      type: String,
      default: 'primary',
    },
    actionClass: String,
    onError: Function,
    onSuccess: Function,
  },
  computed: {
    canConfirm() {
      return this.confirmationInput.trim() === this.expectedText;
    }
  },
  methods: {
    cancel: function () {
      this.open = false
      this.confirmationInput = ''
    },
    callAction: async function () {
      if (!this.canConfirm) return;
      
      this.loading = true
      try {
        const res = await this.action();
        if (this.onSuccess) this.onSuccess(res);
        this.open = false;
        this.confirmationInput = '';
      } catch (err) {
        if (this.onError) this.onError(err);
      } finally {
        this.loading = false;
      }
    },
  },
  data: () => ({
    open: false,
    loading: false,
    confirmationInput: '',
  }),
}
</script>

<style scoped></style>
